import type { ScreenModule } from "../../../app/screen-module";
import { UcsWeb001Page } from "./Page";

export default {
	id: "end-user.ucs-web-001",
	path: "/app/ucs-web-001",
	area: "end-user",
	navGroup: "はたらく",
	label: "LPを作る",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	demo: { allowed: true, constraints: ["no-persist"] },
	enabled: true,
	component: UcsWeb001Page,
} satisfies ScreenModule;
